import { Settings as SettingsIcon, Globe, Shield, Bell } from 'lucide-react';

const SettingRow = ({ label, description, children }) => (
  <div className="flex items-center justify-between py-4 border-b border-slate-100 last:border-0">
    <div>
      <p className="text-sm font-semibold text-slate-900">{label}</p>
      <p className="text-xs text-slate-400 mt-0.5">{description}</p>
    </div>
    <div>{children}</div>
  </div>
);

export default function Settings() {
  return (
    <div className="space-y-6 max-w-2xl" data-testid="admin-settings-page">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">Settings</h1>
        <p className="text-slate-500 text-sm mt-0.5">Platform configuration and preferences</p>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 p-6">
        <div className="flex items-center gap-2 mb-4">
          <Globe className="w-5 h-5 text-slate-500" />
          <h2 className="font-heading text-base font-semibold text-slate-900">Platform Settings</h2>
        </div>
        <SettingRow label="Platform Name" description="The name shown across the portal">
          <span className="text-sm font-semibold text-slate-700">DeMaxtore Portal</span>
        </SettingRow>
        <SettingRow label="Default Currency" description="Base currency for transactions">
          <span className="text-sm font-semibold text-slate-700">USD</span>
        </SettingRow>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 p-6">
        <div className="flex items-center gap-2 mb-4">
          <Shield className="w-5 h-5 text-slate-500" />
          <h2 className="font-heading text-base font-semibold text-slate-900">Security</h2>
        </div>
        <SettingRow label="Session Timeout" description="Auto-logout after inactivity">
          <span className="text-sm font-semibold text-slate-700">24 hours</span>
        </SettingRow>
        <SettingRow label="Two-Factor Auth" description="Require 2FA for all accounts">
          <span className="text-xs bg-amber-50 text-amber-700 font-semibold px-2.5 py-0.5 rounded-full">Coming Soon</span>
        </SettingRow>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 p-6">
        <div className="flex items-center gap-2 mb-4">
          <Bell className="w-5 h-5 text-slate-500" />
          <h2 className="font-heading text-base font-semibold text-slate-900">Notifications</h2>
        </div>
        <SettingRow label="Email Notifications" description="Send emails for new requests and offers">
          <span className="text-xs bg-amber-50 text-amber-700 font-semibold px-2.5 py-0.5 rounded-full">Coming Soon</span>
        </SettingRow>
      </div>
    </div>
  );
}
